import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, timeout } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonService } from './common.service';
import { HotToastService } from '@ngneat/hot-toast';
import { StorageService } from './storage.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { EMPTY } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { TimerDialogComponent } from '../../timer-dialog/timer-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class InterceptService implements HttpInterceptor {
  loader: any;
  isLocked: boolean = false;

  constructor(
    private router: Router,
    private toastr: ToastrService,
    private commonService: CommonService,
    private ngxUiLoaderService: NgxUiLoaderService,
    private toast: HotToastService,
    private storageService: StorageService,
    private dialog: MatDialog
  ) {
    this.loader = this.ngxUiLoaderService.getLoader();
  }
  /**
   * intercept all XHR request
   * @param request
   * @param next
   * @returns {Observable<A>}
   */
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    //added by mayuri for Lack of Security Headers 
    //request = request.clone({
    //  setHeaders: {
    //    'X-Frame-Options': 'DENY',
    //    'X-Content-Type-Options': 'nosniff',
    //    'Referrer-Policy': 'strict-origin-when-cross-origin',
    //    'Permissions-Policy': 'geolocation=(), microphone=()'
    //  }
    //});


    /**
     * continues request execution
     */

    //const userToken = this.storageService.get('token');

    // request = request.clone({
    //   setHeaders: { 'Accept-Encoding': 'gzip' },
    // });
    //pass auth token
    // if (userToken) {
    //   request = request.clone({
    //     setHeaders: { 'Authorization': `Bearer ${userToken}` },
    //   });
    // }
    setTimeout(
      () => this.ngxUiLoaderService.stop(),
      500
    );

    return next.handle(request).pipe(
      timeout(60000),

      catchError((error, caught) => {

        this.handleAuthError(error);

        setTimeout(
          () => this.ngxUiLoaderService.stop(),
          500
        );
        return of(error);
      }) as any
    );
  }

  /**
   * manage-patients errors
   * @param err
   * @returns {any}
   */
  private handleAuthError(err: HttpErrorResponse): Observable<any> {
    if (err.status === 401) {
      const userToken = this.storageService.get('isUserLoggedIn');
      // const adminUserLogin = this.storageService.get('isAdminLoggedIn');

      setTimeout(
        () => this.ngxUiLoaderService.stop(),
        500
      );



      if (userToken) {
        this.toastr.error(err.error?.message ?? 'Unauthorized! Please login');
        this.commonService.logout();
        /*} else {*/
        this.router.navigate(['/login']);
      }
      //if (adminUserLogin) {
      //  this.commonService.logout();
      //} else {
      //  this.router.navigate(['/adminlogin']);
      //}
      // this.toastr.error('Unauthorized! Please login', 'Error!', { timeOut: 5000 });
      if (
        err.error?.message === 'Empty token' &&
        !this.commonService.emptyTokenErrorShown
      ) {
        this.commonService.emptyTokenErrorShown = true;

        this.toastr.error(err.error.message);
      } else {

        this.toastr.error(err.error?.message ?? 'Unauthorized! Please login');
      }
      this.dialog.closeAll();
      //this.commonService.logout();
      // return of(err.message);
      // return of('err.message');
      return of(err.error.message);
    }

    if (err.status === 403) {
      setTimeout(
        () => this.ngxUiLoaderService.stop(),
        500
      );
      //this.toastr.error('Unauthorized to access this API', 'Error!', { timeOut: 5000 });

      if (err.error?.message == "Too many failed attempts. Try again later.") {
        this.openTimerDialog(180); // 3-minute timer

      }

      if (
        err.error?.message === 'Empty token' &&
        !this.commonService.emptyTokenErrorShown
      ) {

        this.commonService.emptyTokenErrorShown = true;

        this.toastr.error(err.error.message);
      } else {

        this.toastr.error(err.error?.message ?? 'Access Denied.');
      }
      // this.dialog.closeAll();

      return of(err.error.message);
    }

    if (err.status === 409) {
      setTimeout(
        () => this.ngxUiLoaderService.stop(),
        500
      );
      var errorMessage = err.error.response
        ? err.error.response.message
        : err.error.Message;
      errorMessage = errorMessage ? errorMessage : err.error.message;
      if (err.error.message === 'Empty token') {
        this.dialog.closeAll();
      }
      this.toastr.error(errorMessage);
      // return of(err.message);
    }

    if (err.status === 500) {
      setTimeout(
        () => this.ngxUiLoaderService.stop(),
        500
      );
      var errorMessage = err.error.response
        ? err.error.response.message
        : err.error.Message;
      errorMessage = errorMessage ? errorMessage : err.error.message;
      if (err.error.message === 'Empty token') {
        this.dialog.closeAll();
      }

      // this.commonService.disableAllDialogs();
      this.toastr.error(
        '',
        'Something went wrong.Please contact administrator for this error.'
      );

      // return of(err.message);
    }

    if ([400, 410, 404].indexOf(err.status) != -1) {

      setTimeout(() => this.ngxUiLoaderService.stop(), 500);
      var errorMessage = err.error.response
        ? err.error.response.message
        : err.error.Message;
      errorMessage = errorMessage ? errorMessage : err.error.message;
      if (
        err.error.message === 'Empty token' &&
        !this.commonService.emptyTokenErrorShown
      ) {
        this.commonService.emptyTokenErrorShown = true;

        this.toastr.error(errorMessage);
      } else if (errorMessage) {
        this.toastr.error(errorMessage);
      } else {
        this.toastr.error('No Records Found');
      }
      // this.dialog.closeAll();
      // this.toastr.error(errorMessage);

      // this.toast.error(err.error.message)
    }

    // Handle 429 Too Many Requests
    if (err.status === 429) {
      setTimeout(
        () => this.ngxUiLoaderService.stop(),
        500
      );
      this.toastr.error('Too Many Requests', 'Error!', { timeOut: 5000 });
      this.toast.error(err.error.message);
      if (err.error.message === 'Empty token') {
        this.dialog.closeAll();
      }
      return of('Too Many Requests');
    }

    if (err.status == 0) {
      this.router.navigate(['/userlogin']);
      setTimeout(
        () => this.ngxUiLoaderService.stop(),
        500
      );
      //this.toastr.error('Network Issue Or Some Error Occured', 'Error!', {
      //  timeOut: 5000,
      //});
      this.toast.error(err.error.Message);
      if (err.error.message === 'Empty token') {
        this.dialog.closeAll();
      }
      return of('Some Error Occured');
    }

    this.ngxUiLoaderService.stop;
    //return EMPTY;
    throw err;
  }


  openTimerDialog(duration: number) {
    const dialogRef = this.dialog.open(TimerDialogComponent, {
      width: '400px',
      disableClose: true, // Prevent user from closing manually
      data: { duration },
    });

    dialogRef.afterClosed().subscribe(() => {
      //console.log("✅ Timer completed. Unlocking user.");
      this.isLocked = false;

      // ✅ Move focus to a safe element (e.g., login button or body)
      setTimeout(() => {
        const loginButton = document.getElementById('btnlogin');
        if (loginButton) {
          loginButton.focus();
        } else {
          document.body.focus();
        }
      }, 0);  // Small delay ensures Angular updates first
    });
  }
}
